import {
  Sidebar,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarScrollWrapper,
  SidebarSpace,
} from '@backstage/core-components';
import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { SidebarLogo } from './SidebarLogo';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import StorageIcon from '@material-ui/icons/Storage';
import { SidebarSearchModal } from '@backstage/plugin-search';
import { UserSettingsSignInAvatar } from '@backstage/plugin-user-settings';
import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { useTranslationRef } from '@backstage/frontend-plugin-api';
import { notificationsTranslationRef } from '@backstage/plugin-notifications/alpha';
import { appTranslationRef } from '../../translations/app';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => {
      const { t } = useTranslationRef(appTranslationRef);
      const { t: notificationsT } = useTranslationRef(
        notificationsTranslationRef,
      );
      const nav = navItems.withComponent(item => (
        <SidebarItem icon={() => item.icon} to={item.href} text={item.title} />
      ));
      const renderNavItem = (id: string, text: string) => {
        const item = navItems.take(id);

        return item ? (
          <SidebarItem icon={() => item.icon} to={item.href} text={text} />
        ) : null;
      };

      // Skipped items
      nav.take('page:search'); // Using search modal instead
      nav.take('page:notifications'); // Using the localized sidebar item below
      const visualizerNavItem = renderNavItem(
        'page:app-visualizer',
        t('navigation.visualizer'),
      );
      const settingsNavItem = renderNavItem(
        'page:user-settings',
        t('navigation.settings'),
      );

      return (
        <Sidebar>
          <SidebarLogo />
          <SidebarGroup
            label={t('navigation.search')}
            icon={<SearchIcon />}
            to="/search"
          >
            <SidebarSearchModal />
          </SidebarGroup>
          <SidebarDivider />
          <SidebarGroup label={t('navigation.menu')} icon={<MenuIcon />}>
            {renderNavItem('page:catalog', t('navigation.catalog'))}
            {renderNavItem('page:scaffolder', t('navigation.create'))}
            <SidebarItem
              icon={StorageIcon}
              text={t('navigation.databaseCredentials')}
              to="/database-credentials"
            />
            <SidebarDivider />
            <SidebarScrollWrapper>
              {renderNavItem(
                'page:catalog-graph',
                t('navigation.catalogGraph'),
              )}
              {renderNavItem(
                'page:catalog-import',
                t('navigation.registerExisting'),
              )}
              {nav.rest({ sortBy: 'title' })}
            </SidebarScrollWrapper>
          </SidebarGroup>
          <SidebarSpace />
          <SidebarDivider />
          <NotificationsSidebarItem text={notificationsT('sidebar.title')} />
          <SidebarDivider />
          <SidebarGroup
            label={t('navigation.settings')}
            icon={<UserSettingsSignInAvatar />}
            to="/settings"
          >
            {visualizerNavItem}
            {settingsNavItem}
          </SidebarGroup>
        </Sidebar>
      );
    },
  },
});
